import { Chip } from '@mui/material';

export const FilterSideChip = ({
  label,
  onClick,
  disabled,
  isSelected,
}: {
  label: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  isSelected: boolean;
}) => {
  return (
    <Chip
      label={label}
      onClick={onClick}
      disabled={disabled}
      sx={{
        p: '3px',
        mr: 1,
        mb: 1,
        fontSize: 12,
        boxShadow: '0 1px 3px 1px rgba(0, 0, 0, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.3)',
        borderRadius: 2,
        height: 22,
        color: isSelected ? 'white' : '#525252',
        cursor: 'pointer',
        backgroundColor: (theme) => (isSelected ? theme.palette.primary.main : 'auto'),
        '&:hover': {
          backgroundColor: (theme) => (isSelected ? theme.palette.primary.main : 'auto'),
        },
      }}
    />
  );
};
